module.exports = __webpack_public_path__ + "assets/img/1_1666_big.b7825872.jpg";